/**
 * Copyright (c) 2022 Wizart Animation.
 *
 * CONFIDENTIAL AND PROPRIETARY
 *
 * This work is provided "AS IS" and subject to the Prodtrack
 * Source Code License. By accessing, using, copying or modifying
 * this work you indicate your agreement to the Prodtrack Source Code License.
 * All rights not expressly granted therein are reserved by Wizart Animation.
 */

export const ACTIVITY = "activity";
export const ASSETS = "assets";
export const ASSET_INSTANCES = "asset_instances";
export const ASSET_TYPES = "asset_types";
export const BUGS = "bugs";
export const DEPARTMENTS = "departments";
export const EPISODES = "episodes";
export const FILES = "files";
export const GROUPS = "groups";
export const NOTES = "notes";
export const PAGE_CONFIGS = "page_configs";
export const PIPELINE_STEPS = "pipeline_steps";
export const PROJECTS = "projects";
export const PUBLISHED_FILES = "published_files";
export const PUBLISHED_FILE_TYPES = "published_file_types";
export const SCENES = "scenes";
export const SERIES = "series";
export const STATUSES = "statuses";
export const STATUS_CONFIGS = "status_configs";
export const STATUS_TYPES = "status_types";
export const TAGS = "tags";
export const TASKS = "tasks";
export const TASK_TEMPLATES = "task_templates";
export const TIME_LOGS = "time_logs";
export const UPLOADED_FILES = "uploaded_files";
export const USERS = "users";
export const VERSIONS = "versions";
export const MENU_ITEMS = "menu_items";
export const FIELDS = "fields";

const entityTypes = {
    ACTIVITY,
    ASSETS,
    ASSET_INSTANCES,
    ASSET_TYPES,
    BUGS,
    DEPARTMENTS,
    EPISODES,
    FILES,
    GROUPS,
    NOTES,
    PAGE_CONFIGS,
    PIPELINE_STEPS,
    PROJECTS,
    PUBLISHED_FILES,
    PUBLISHED_FILE_TYPES,
    SCENES,
    SERIES,
    STATUSES,
    STATUS_CONFIGS,
    STATUS_TYPES,
    TAGS,
    TASKS,
    TASK_TEMPLATES,
    TIME_LOGS,
    UPLOADED_FILES,
    USERS,
    VERSIONS,
    MENU_ITEMS,
    FIELDS,
};

export const relatedContentTypes = {
    [entityTypes.ASSETS]: "asset",
    [entityTypes.ASSET_INSTANCES]: "assetinstance",
    [entityTypes.ASSET_TYPES]: "assettype",
    [entityTypes.BUGS]: "bug",
    [entityTypes.DEPARTMENTS]: "department",
    [entityTypes.EPISODES]: "episode",
    [entityTypes.NOTES]: "note",
    [entityTypes.PAGE_CONFIGS]: "pageconfig",
    [entityTypes.PIPELINE_STEPS]: "pipelinestep",
    [entityTypes.PROJECTS]: "project",
    [entityTypes.PUBLISHED_FILES]: "publishedfile",
    [entityTypes.PUBLISHED_FILE_TYPES]: "publishedfiletype",
    [entityTypes.SCENES]: "scene",
    [entityTypes.SERIES]: "series",
    [entityTypes.STATUSES]: "status",
    [entityTypes.STATUS_TYPES]: "statustype",
    [entityTypes.TAGS]: "tag",
    [entityTypes.TASKS]: "task",
    [entityTypes.TASK_TEMPLATES]: "tasktemplate",
    [entityTypes.TIME_LOGS]: "timelog",
    [entityTypes.UPLOADED_FILES]: "uploadedfile",
    [entityTypes.USERS]: "user",
    [entityTypes.VERSIONS]: "version",
    [entityTypes.MENU_ITEMS]: "menuitem",
};

export const relatedEntityTypes = {
    asset: entityTypes.ASSETS,
    assetinstance: entityTypes.ASSET_INSTANCES,
    bug: entityTypes.BUGS,
    department: entityTypes.DEPARTMENTS,
    episode: entityTypes.EPISODES,
    project: entityTypes.PROJECTS,
    publishedfile: entityTypes.PUBLISHED_FILE_TYPES,
    scene: entityTypes.SCENES,
    series: entityTypes.SERIES,
    task: entityTypes.TASKS,
    tasktemplate: entityTypes.TASK_TEMPLATES,
    version: entityTypes.VERSIONS,
    user: entityTypes.USERS,
    note: entityTypes.NOTES,
};

export const relatedLinkTypes = {
    [entityTypes.ASSETS]: "asset",
    [entityTypes.ASSET_INSTANCES]: "asset_instance",
    [entityTypes.EPISODES]: "episode",
    [entityTypes.PROJECTS]: "project",
    [entityTypes.SCENES]: "scene",
    [entityTypes.SERIES]: "series",
    [entityTypes.TASK_TEMPLATES]: "task_template",
};

export default entityTypes;
